module.exports = __webpack_public_path__ + "static/media/banner_blue.791a92a5.jpg";